import { Property } from 'api/clients/PropertyClient'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'
import { useCurrentArticleMeta } from './useCurrentArticleMeta'
import { useFolder } from './queries/folders/useFolder'

type ReturnType = {
  canCreate: boolean
  canEdit: boolean
  canRemove: boolean
}

export const usePropertiesPermissions = (property?: Property | null): ReturnType => {
  const workspace = useCurrentWorkspace()
  const { currentFolder: folder } = useCurrentFolderStore()
  const articleMeta = useCurrentArticleMeta()
  const articleEditAccess = ['edit', 'owner'].includes(articleMeta?.current_user_access || '')
  const scopeProject = useFolder(property?.scope_project_id)

  const canCreate = () => {
    if (property?.id) return false
    if (property?.default_type) return false

    return folder?.has_edit_access || workspace?.admin
  }

  const canEdit = () => {
    if (!property) return false
    if (property.default_type) return false
    if (property.property_tag) return false

    if (property.scope_project_id) {
      return folder?.has_edit_access && !!scopeProject?.data?.folder?.has_edit_access
    }

    return workspace?.admin
  }

  // used on article level, if used elsewhere, maybe it needs adapting
  const canRemove = () => {
    if (!property) return false
    if (property.default_type) return false
    if (property.scope_project_id) return false
    if (property.default_for_articles) return false
    if (property.property_tag) return false

    return workspace?.admin || articleEditAccess
  }

  return {
    canEdit: !!canEdit(),
    canCreate: !!canCreate(),
    canRemove: !!canRemove(),
  }
}
